import './components/calculators/format';
import './components/calculators/finance';
import './components/calculators/calculator-products';
import './components/calculators/mortgage';
import './components/calculators/input';
import './components/calculators/products';

// =====================================================================
//  SYARIAH PERSONAL LOAN — interactivity layer
//  Static markup lives in syariah-personal-loan.html.
// =====================================================================
(function () {
  const fmt = Calc.format;
  const fin = Calc.finance;

  const REF_AMOUNTS = [10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000,
                       50000, 55000, 60000, 65000, 70000, 75000, 80000, 90000,
                       100000, 150000, 200000, 250000, 300000, 350000, 400000];
  const REF_TENURES = [2, 3, 4, 5, 6, 7, 8, 9, 10];

  const state = {
    amount: 100000,
    profitRate: 0.0288,
    tenure: 10,
    activeTab: 'breakdown',
    sort: { key: 'best', dir: 'asc' },    // template's selected option sets the default
  };

  const setText = (id, val) => {
    const el = document.getElementById(id);
    if (el) el.textContent = val;
  };
  // Write a value into a placeholder span (text is in HTML, JS only writes the value).
  const setVal = (sel, val) => {
    const el = document.querySelector(sel);
    if (el) el.textContent = val;
  };
  const syncInput = (id, val) => Calc.input.syncValue(id, val);
  // Escape dynamic strings before injecting as HTML (bank names / reason text
  // originate from the external product feed).
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ));

  function updateStatBand() {
    const calc = fin.flatRate(state.amount, state.profitRate, state.tenure);
    const effRate = fin.solveEffectiveRate(state.amount, calc.monthlyInstalment, state.tenure);
    setText('sp-stat-monthly', fmt.money(calc.monthlyInstalment, 0));
    setText('sp-stat-effrate', fmt.percent(effRate));
    setText('sp-stat-profit',  fmt.money(calc.totalInterest, 0));
    setText('sp-stat-total',   fmt.money(calc.totalRepayment, 0));
  }

  function updateBreakdown() {
    const calc = fin.flatRate(state.amount, state.profitRate, state.tenure);
    const effRate = fin.solveEffectiveRate(state.amount, calc.monthlyInstalment, state.tenure);
    const spread = fin.effectiveToSBRSpread(effRate, 0.03);

    setText('sp-r-amount',  fmt.money(state.amount));
    setVal('.sp-r-tenure-y', state.tenure);
    setVal('.sp-r-tenure-m', state.tenure * 12);
    setVal('.sp-r-flat-num', fmt.percent(state.profitRate));
    setVal('.sp-r-eff-num',  fmt.percent(effRate));
    setVal('.sp-r-sbr-num',  fmt.percent(spread));
    setText('sp-r-profit',  fmt.money(calc.totalInterest));
    setText('sp-r-total',   fmt.money(calc.totalRepayment));
    setText('sp-r-monthly', fmt.money(calc.monthlyInstalment));
  }

  function updateAmortization() {
    const host = document.getElementById('sp-amort');
    if (!host) return;
    Calc.amortView.renderInline(host, {
      startExpanded: true,
      amount: state.amount,
      rate: state.profitRate,
      years: state.tenure,
      method: 'flat',
    });
  }

  function updateReferenceGrid() {
    setVal('.sp-grid-rate-num', fmt.percent(state.profitRate));
    const tbody = document.getElementById('sp-grid-tbody');
    if (!tbody) return;
    tbody.innerHTML = REF_AMOUNTS.map(amt => {
      const isHighRow = amt === state.amount;
      const cells = REF_TENURES.map(t => {
        const monthly = fin.flatRate(amt, state.profitRate, t).monthlyInstalment;
        const isHighCol = t === state.tenure;
        return `<td class="${isHighCol ? 'highlight-col' : ''}">${fmt.number(monthly, 0)}</td>`;
      }).join('');
      return `<tr class="${isHighRow ? 'highlight' : ''}"><th>RM ${amt.toLocaleString()}</th>${cells}</tr>`;
    }).join('');
  }

  function updateBankCards() {
    const wraps = document.querySelectorAll('.bank-card-wrap');
    const emptyState = document.querySelector('.bank-empty-state');

    // First pass: filter + compute per eligible card.
    const eligible = [];
    const ineligibleReasons = [];
    wraps.forEach((wrap, i) => {
      // data-rate carries the bank's quoted flat profit rate as a percentage
      // (e.g. 2.88). Convert once to decimal for the finance functions.
      const bankRate = (+wrap.dataset.rate) / 100;
      if (!bankRate) { wrap.classList.add('d-none'); return; }

      // Filter: exclude lenders whose [minAmount, maxAmount] or
      // [minTenure, maxTenure] range doesn't fit the user's financing amount
      // and chosen tenure. Each failed bound emits a structured reason code;
      // the wording lives in the elig-templates partial (data-elig-tpl-*),
      // rendered here via Calc.eligibility.renderReasons — no strings in JS.
      const minAmt = +wrap.dataset.minAmount || 0;
      const maxAmt = +wrap.dataset.maxAmount || Infinity;
      const minTen = +wrap.dataset.minTenure || 0;
      const maxTen = +wrap.dataset.tenure    || Infinity;

      const reasons = [];
      if (state.amount < minAmt) reasons.push({ code: 'min_loan', params: { min: minAmt } });
      if (state.amount > maxAmt) reasons.push({ code: 'max_loan', params: { max: maxAmt } });
      if (state.tenure < minTen || state.tenure > maxTen) {
        reasons.push({ code: 'tenure_range', params: { min: minTen, max: maxTen } });
      }
      const isEligible = reasons.length === 0;

      wrap.classList.toggle('d-none', !isEligible);
      if (!isEligible) {
        const name = wrap.querySelector('.bank-logo')?.alt || `#${wrap.dataset.bankId}`;
        const rendered = (typeof Calc.eligibility?.renderReasons === 'function')
          ? Calc.eligibility.renderReasons(reasons)
          : reasons.map(r => r.code);
        ineligibleReasons.push(`<strong>${esc(name)}:</strong> ${esc(rendered.join('; '))}`);
        return;
      }

      // Syariah financing is flat-rate. Compute at the user's amount + tenure
      // (guaranteed within range by the filter) using the bank's profit rate.
      const r = fin.flatRate(state.amount, bankRate, state.tenure);

      const tenEl = wrap.querySelector('.bank-tenure');
      if (tenEl) tenEl.textContent = `${state.tenure} year${state.tenure === 1 ? '' : 's'}`;

      const m = wrap.querySelector('.bank-monthly');
      const t = wrap.querySelector('.bank-total');
      if (m) m.textContent = fmt.money(r.monthlyInstalment, 0);
      if (t) t.textContent = fmt.money(r.totalRepayment, 0);

      const apply = wrap.querySelector('.bank-apply');
      const base  = wrap.dataset.applyUrl;
      if (apply && base) {
        try {
          const url = new URL(base);
          url.searchParams.set('amount', state.amount);
          url.searchParams.set('tenure', state.tenure);
          apply.href = url.toString();
        } catch (e) { apply.href = base; }
      }

      eligible.push({
        wrap,
        index: i,
        name: wrap.querySelector('.bank-apply')?.dataset.value || '',
        // Only axes that actually reorder the visible cards (see products.js).
        metrics: { best: r.monthlyInstalment },
      });
    });

    // Second pass: mark the lowest-monthly card as "Best Offer".
    // Badge = best value; order = the user's chosen sort.
    const bestWrap = eligible.length
      ? Calc.products.rank(eligible, 'best', 'asc')[0].wrap
      : null;
    Calc.products.applyOrder(
      wraps,
      Calc.products.rank(eligible, state.sort.key, state.sort.dir),
      bestWrap
    );

    if (emptyState) emptyState.classList.toggle('d-none', eligible.length > 0);

    // "Not eligible for" panel — list each excluded lender and why.
    const note = document.getElementById('sp-ineligible-note');
    const reasonsEl = document.getElementById('sp-ineligible-reasons');
    if (note && reasonsEl) {
      if (ineligibleReasons.length) {
        note.classList.remove('d-none');
        reasonsEl.innerHTML = ineligibleReasons.join('\n');
      } else {
        note.classList.add('d-none');
      }
    }
  }

  function refresh() {
    syncInput('sp-amount-input', state.amount);
    syncInput('sp-rate-input',   (state.profitRate * 100).toFixed(2));
    syncInput('sp-tenure-input', state.tenure);

    updateStatBand();
    updateBankCards();

    if (state.activeTab === 'breakdown') {
      updateBreakdown();
      updateAmortization();
    } else {
      updateReferenceGrid();
    }
  }

  function activateTab(tabId) {
    state.activeTab = tabId;
    document.querySelectorAll('#sp-tabs .btn-tab').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.tab === tabId);
    });
    document.querySelectorAll('.tab-panel').forEach(panel => {
      panel.classList.toggle('d-none', panel.id !== `sp-tab-${tabId}`);
    });
    if (tabId === 'breakdown') { updateBreakdown(); updateAmortization(); }
    else { updateReferenceGrid(); }
  }

  function bindEvents() {
    ['input', 'change'].forEach(evt => document.addEventListener(evt, (e) => {
      const id = e.target.id;
      const v = Calc.input.getValue(e.target);
      if (id === 'sp-amount-input') { state.amount = v || 0;               refresh(); }
      if (id === 'sp-rate-input')   { state.profitRate = (v || 0) / 100;   refresh(); }
      if (id === 'sp-tenure-input') { state.tenure = v || 1;               refresh(); }
    }));

    document.querySelectorAll('#sp-tabs .btn-tab').forEach(btn => {
      btn.addEventListener('click', () => activateTab(btn.dataset.tab));
    });

    const initialSort = Calc.products.bindSort('#sp-sort-select', (sort) => {
      state.sort = sort;
      updateBankCards();
    });
    if (initialSort) state.sort = initialSort;
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindEvents();
    refresh();
  });
})();